import { Form as OldForm } from 'reactstrap'

export const Form = ({ children, ...props }) => {
  return <OldForm {...props}>{children}</OldForm>
}
